import React from 'react';
import { deleteUserProject } from '../../../modules/project';
import ConfirmationModal from '../../elements/ConfirmationModal';
import { useNotification } from '../../../hooks/NotificationContext';
import { useInvalidateQuery } from '../../../query/apiQueries';

export const deletionIssues = [
  'All test cases linked to the project, including steps, linked issues, and histories',
  'All test cycles, test executions, and their respective iterations',
  'All attachments (files, images, etc.) and comments linked to the project',
  'All configuration settings, including test environments and integrations',
  'All associated users and their project-specific roles and permissions',
  'Any related project data',
];

const DeleteProject = ({
  open,
  handleDeleteCancel,
  selectedProject,
  setDeleteConfirmationOpen,
  fetchProjectData
}) => {
  const { addNotification } = useNotification();
  const invalidateQueries = useInvalidateQuery();
  const handleDeleteConfirm = async () => {
    try {
      await deleteUserProject(selectedProject.id);
      setDeleteConfirmationOpen(false);
      addNotification('success', 'Project deleted successfully!');
      fetchProjectData();
      invalidateQueries([
        { key: 'project', type: 'headerProjects' },
        { key: 'project', type: 'dashboardProjects' },
        { key: 'project', type: 'list' },
      ]);
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <ConfirmationModal
      show={open}
      handleClose={handleDeleteCancel}
      handleConfirm={handleDeleteConfirm}
      title="Remove Project"
      body={
        <>
          <p>
            Deleting the project <strong>{selectedProject.name}</strong> will
            permanently remove the following:
          </p>
          <ul>
            {deletionIssues.map((issue, index) => (
              <li key={index}>{issue}</li>
            ))}
          </ul>
          <p>This action cannot be undone.</p>
          <strong>Are you sure you want to delete this project?</strong>
        </>
      }
      buttonLabel="Delete"
    />
  );
};

export default DeleteProject;
